module.exports = __webpack_public_path__ + "static/l2-cd050d98aedd6e381c56266b677cbbd5.png";